module.exports = __webpack_public_path__ + "img/transformer-industrial.c7781616.jpg";